import { render, staticRenderFns } from "./LinhaProdutoModal.vue?vue&type=template&id=02c84839&scoped=true"
import script from "./LinhaProdutoModal.vue?vue&type=script&lang=js"
export * from "./LinhaProdutoModal.vue?vue&type=script&lang=js"
import style0 from "./LinhaProdutoModal.vue?vue&type=style&index=0&id=02c84839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c84839",
  null
  
)

export default component.exports